import { h } from "@stencil/core";
import { injectFont, injectCSS } from "../../utils";
import { createStyles } from "./text-styles";
export class DcUiText {
    constructor() {
        this.tag = 'span';
        this.textAlign = 'left';
        this.variant = 'text';
        this.color = 'inherit';
    }
    componentWillLoad() {
        injectFont();
    }
    render() {
        injectCSS(this.el, createStyles, this.tag, this.variant, this.color, this.textAlign, this.weight);
        return (h(this.tag, { key: '18ec50d51e7a41be0e7fd0aa7d513c63f1d35543' }, h("slot", { key: 'b364ce7c9f0aa6208b5a14db0b10524054cbbf2d' })));
    }
    static get is() { return "dc-ui-text"; }
    static get encapsulation() { return "shadow"; }
    static get properties() {
        return {
            "tag": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TTextTag",
                    "resolved": "\"address\" | \"blockquote\" | \"cite\" | \"div\" | \"figcaption\" | \"legend\" | \"p\" | \"span\" | \"time\"",
                    "references": {
                        "TTextTag": {
                            "location": "import",
                            "path": "./text-utils",
                            "id": "src/components/dc-ui-text/text-utils.ts::TTextTag"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "tag",
                "reflect": false,
                "defaultValue": "'span'"
            },
            "textAlign": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TTextAlign",
                    "resolved": "string | { base?: \"center\" | \"left\" | \"right\"; xs?: \"center\" | \"left\" | \"right\"; sm?: \"center\" | \"left\" | \"right\"; md?: \"center\" | \"left\" | \"right\"; lg?: \"center\" | \"left\" | \"right\"; xl?: \"center\" | \"left\" | \"right\"; } & { base: \"center\" | \"left\" | \"right\"; }",
                    "references": {
                        "TTextAlign": {
                            "location": "import",
                            "path": "./text-utils",
                            "id": "src/components/dc-ui-text/text-utils.ts::TTextAlign"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "text-align",
                "reflect": false,
                "defaultValue": "'left'"
            },
            "weight": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TTextWeight",
                    "resolved": "string | { base?: \"900\" | \"bold\" | \"inherit\" | \"normal\"; xs?: \"900\" | \"bold\" | \"inherit\" | \"normal\"; sm?: \"900\" | \"bold\" | \"inherit\" | \"normal\"; md?: \"900\" | \"bold\" | \"inherit\" | \"normal\"; lg?: \"900\" | \"bold\" | \"inherit\" | \"normal\"; xl?: \"900\" | \"bold\" | \"inherit\" | \"normal\"; } & { base: \"900\" | \"bold\" | \"inherit\" | \"normal\"; }",
                    "references": {
                        "TTextWeight": {
                            "location": "import",
                            "path": "./text-utils",
                            "id": "src/components/dc-ui-text/text-utils.ts::TTextWeight"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "weight",
                "reflect": false
            },
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TTextVariant",
                    "resolved": "\"h1\" | \"h2\" | \"h3\" | \"h4\" | \"h5\" | \"h6\" | \"text\" | \"state-message\" | \"h-superbig\" | \"h-big\" | \"emphasized-text\" | \"emphasized-additional-text\" | \"intro-text\" | \"text-line-spacing-big\" | \"strong-text\" | \"mid-size-text\" | \"strong-mid-size-text\" | \"small-text\" | \"strong-small-text\" | \"btn-small\" | \"btn-normal\" | \"btn-large\" | \"link-small\" | \"link-normal\" | \"label-checkbox\" | \"label-textarea\" | \"label-input\"",
                    "references": {
                        "TTextVariant": {
                            "location": "import",
                            "path": "./text-utils",
                            "id": "src/components/dc-ui-text/text-utils.ts::TTextVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "variant",
                "reflect": false,
                "defaultValue": "'text'"
            },
            "color": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TTextColor",
                    "resolved": "string | { base?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; xs?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; sm?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; md?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; lg?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; xl?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; } & { base: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; }",
                    "references": {
                        "TTextColor": {
                            "location": "import",
                            "path": "./text-utils",
                            "id": "src/components/dc-ui-text/text-utils.ts::TTextColor"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "color",
                "reflect": false,
                "defaultValue": "'inherit'"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=dc-ui-text.js.map
